import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-animations',
  templateUrl: './animations.component.html',
  styleUrls: ['./animations.component.css']
})
export class AnimationsComponent implements OnInit {

  showingRotationAnimation: boolean = false;
  showingVerticalFingerAnimation: boolean = false;
  showingHorizontalFingerAnimation: boolean = false;

  @ViewChild('ScreenRotation') screenRotation!: ElementRef;
  @ViewChild('VFinger') verticalFinger!: ElementRef;
  @ViewChild('HFinger') horizontalFinger!: ElementRef;

  constructor(
    private cdr: ChangeDetectorRef,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
    if (!environment.production) {
      setInterval(() => {
        this.cancelAnimations();
      }, 50)
    };
  }

  showTurnScreenAnimation(): Promise<void> {
    this.showingRotationAnimation = true;

    return new Promise((resolve, reject) => {
      // Esperamos a que se cargue el elemento medio segundo y le aumentamos el tamaño
      setTimeout(() => {
        const element = document.getElementById('ScreenRotation')!
        element.parentElement!.style.height = '70vw';
        element.parentElement!.style.width = '70vw';
        setTimeout(() => {
          element.parentElement!.style.height = '50vw';
          element.parentElement!.style.width = '50vw';
          setTimeout(() => {
            element.parentElement!.style.height = '70vw';
            element.parentElement!.style.width = '70vw';
            setTimeout(() => {
              element.parentElement!.style.height = '50vw';
              element.parentElement!.style.width = '50vw';
              setTimeout(() => {
                if (!this.showingRotationAnimation) {
                  reject()
                }
                else {
                  this.showingRotationAnimation = false;
                  resolve();
                }
              }, 700);
            }, 700);
          }, 700);
        }, 700);
      }, 250);
    })
  }

  showFingerAnimation(ori: 'vertical' | 'horizontal'): Promise<void> {
    if (ori == 'vertical') {
      this.showingVerticalFingerAnimation = true;
      return new Promise((resolve, reject) => {
        if(this.verticalFinger==null) {
          reject();
        } else {
        // Esperamos a que se cargue el elemento medio segundo y lo animamos
        setTimeout(() => {
          const element = this.verticalFinger?.nativeElement as HTMLSpanElement;
          element.style.right = '80%';
          setTimeout(() => {
            if (!this.showingVerticalFingerAnimation) {
              reject()
            } else {
              this.showingVerticalFingerAnimation = false;
              resolve();
            }
          }, 1500);
        }, 500);
      }
      })
    } else {
      this.showingHorizontalFingerAnimation = true;
      this.cdr.detectChanges();
      return new Promise((resolve, reject) => {
        // Esperamos a que se cargue el flipbook medio segundo y animamos el dedo
        const element = this.horizontalFinger.nativeElement as HTMLSpanElement;
        element.style.display = 'none';
        setTimeout(() => {
          const flipbookRect = document.getElementById('flipbook')!.getBoundingClientRect();
          console.log(flipbookRect);
          element.style.left = (flipbookRect.left + flipbookRect.width - 35) + 'px';
          console.log(element.style.left);
          element.style.display = 'block';
          setTimeout(() => {
            element.style.left = flipbookRect.left + 'px';
            console.log(element.style.left);
            setTimeout(() => {
              if (!this.showingHorizontalFingerAnimation) {
                reject();
              } else {
                this.showingHorizontalFingerAnimation = false;
                resolve();
              }
            }, 1500);
          }, 500);
        }, 250);
      })
    }
  }

  cancelAnimations() {
    this.showingRotationAnimation = false;
    this.showingHorizontalFingerAnimation = false;
    this.showingVerticalFingerAnimation = false;
  }

}
